import * as React from 'react';
import { Radio } from 'antd';

const RadioGroup = Radio.Group;

interface MarketEditorCheckListProps {
	markets: MarketSummary[];
	value: number | null;
	mode: ControlMode;
	onChanged: (number: number | null) => void;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class MarketEditorCheckListView extends React.Component<MarketEditorCheckListProps, {}> {
	public render() {
		const { markets, mode, onChanged, value } = this.props;

		const radios = [];
		radios.push(<Radio className="list-radio-filter" value={-1} disabled={mode == "display"}>All</Radio>);
		for (const market of markets) {
			radios.push(
				<Radio className="list-radio-filter" disabled={mode == "display"} value={market.id}>
					{market.name}
				</Radio>
			);
		}
		return (
			<RadioGroup
				disabled={mode == "display"}
				onChange={(e) => {
					if (e.target.value == -1) {
						onChanged(null);
					} else {
						onChanged(e.target.value);
					}
				}}
				value={value != null ? value : -1}
			>
				{radios}
			</RadioGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/market/parts/market-editor-checkList.view.tsx